const checkPostcodeFormat = postcode => {
    return /^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/.test(postcode);
}

export default checkPostcodeFormat;